import { Box } from '@mui/material'
import MiniChart from '@/components/Table/MiniChart'
import { CustomColumnGridConfig } from '../types'
import ParentCard from '@/components/Table/ParentCard'
import dayjs from 'dayjs'
import { isEmptyTableCellValue } from '@/utils/tableCellValue'
import { treeMemberRoleLabel } from '@/services/waterTreeMemberRoles'

// const iconMap: Record<string, string> = {
//   EmailIcon,
//   WhatsappIcon,
//   SmsIcon,
// }

export const CONSUMPTION_FIELD = 'consumption' as const

const columnsConfig: CustomColumnGridConfig[] = [
  {
    field: 'parentCard',
    headerName: 'כרטיס אב',
    hideable: true,
    renderCell: (params: any) => {
      return isEmptyTableCellValue(params.value) ? '-' : <ParentCard value={params.value} />
    },
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    width: 140,
    minWidth: 125,
  },
  {
    field: 'waterCard',
    headerName: 'כרטיס מים',
    hideable: true,
    renderCell: (params: any) => {
      return isEmptyTableCellValue(params.value) ? '-' : <ParentCard value={params.value} />
    },
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    width: 140,
    minWidth: 125,
  },
  {
    field: 'meterNumber',
    headerName: "מס' מד",
    hideable: true,
    filter: {
      type: 'search',
    },
    filterable: true,
    width: 130,
    minWidth: 115,
  },
  {
    field: 'role',
    headerName: 'תפקיד',
    hideable: true,
    disableAggregation: true,
    // format, not renderCell, so the Excel, PDF and copy exports show the label too.
    format: value => ({ kind: 'text', text: treeMemberRoleLabel(value) }),
    // The search and options filters ask the Gateway for a field's values, and
    // it has no role field. Sorting stays, because this grid sorts only the
    // loaded page.
    filter: { type: 'none' },
    filterable: false,
    width: 110,
    minWidth: 95,
  },
  {
    field: 'name',
    headerName: 'שם צרכן',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
    width: 160,
    minWidth: 140,
  },
  {
    field: 'address',
    headerName: 'כתובת',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
    width: 180,
    minWidth: 150,
  },
  {
    field: 'diameter',
    headerName: 'קוטר',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
    width: 110,
    minWidth: 95,
  },
  {
    field: 'payerNumber',
    headerName: 'מספר משלם',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
    width: 150,
    minWidth: 135,
  },
  {
    field: 'area',
    headerName: 'אזור',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
    width: 120,
    minWidth: 100,
  },
  // {
  //     field: 'sent',
  //     headerName: 'נשלח',
  //     filter: {
  //         type: 'none',
  //     },
  //     renderCell: (params: any) => {
  //         const channels: Array<{
  //             channel: string
  //             icon: string
  //         }> = params.row?.sentChannels ?? []

  //         if (channels.length)
  //             return (
  //                 <Box
  //                     sx={{
  //                         display: 'flex',
  //                         alignItems: 'center',
  //                         gap: 1,
  //                         justifyContent: 'center',
  //                         width: '100%',
  //                     }}
  //                 >
  //                     {channels.map((channelObj, index) => (
  //                         <Tooltip key={index} title={channelObj.channel}>
  //                             <img
  //                                 src={iconMap[channelObj.icon]}
  //                                 alt={channelObj.channel}
  //                                 style={{ width: 18, height: 18 }}
  //                             />
  //                         </Tooltip>
  //                     ))}
  //                 </Box>
  //             )
  //     },
  // },
  {
    field: 'capacity',
    headerName: 'ק. חצות',
    type: 'number',
    aggregable: true,
    hideable: true,
    renderCell: (params: any) => {
      return <div>{params.value ?? '-'}</div>
    },
    filter: {
      type: 'aggregated',
    },
    filterable: true,
    width: 125,
    minWidth: 105,
  },
  {
    field: 'dailyUsageData',
    headerName: 'צריכה אחרונה',
    renderCell: (params: any) => {
      if (isEmptyTableCellValue(params.value)) return '-'
      return (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MiniChart data={params.value} />
        </Box>
      )
    },
    // The Gateway has no field for the seven-day series, so no filter can reach every row.
    filter: { type: 'none' },
    filterable: false,
    disableAggregation: true,
    hideable: true,
    width: 175,
    minWidth: 145,
  },
  // {
  //     field: 'crm',
  //     headerName: 'ניהול משימות',
  //     width: 150,
  //     renderCell: (params: any) => {
  //         return params.value ? <CrmStatus value={params.value} /> : null
  //     },
  //     filter: {
  //         type: 'options',
  //     },
  //     hideable: true,
  //     disableAggregation: true,
  //     filterable: true,
  // },
  {
    field: 'contractNumber',
    headerName: 'מספר חוזה',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'none',
    },
    width: 130,
    minWidth: 110,
  },
  {
    field: 'tenantCount',
    headerName: 'מספר נפשות',
    hideable: true,
    filter: { type: 'none' },
    width: 130,
    minWidth: 110,
  },
  {
    field: 'installed',
    headerName: 'תאריך התקנה',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'none',
    },
    filterable: true,
    renderCell: (params: any) => params.value ? dayjs(params.value).format('DD/MM/YYYY') : '-',
    width: 135,
    minWidth: 115,
  },
//   {
//     field: 'phone',
//     headerName: 'מספר טלפון',
//     hideable: true,
//     disableAggregation: true,
//     filter: {
//       type: 'search',
//     },
//     filterable: true,
//   },
//   {
//     field: 'email',
//     headerName: 'אימייל',
//     hideable: true,
//     disableAggregation: true,
//     filter: {
//       type: 'search',
//     },
//     filterable: true,
//   },
//   {
//     field: 'branch',
//     headerName: 'ענף',
//     hideable: true,
//     disableAggregation: true,
//     filter: {
//       type: 'none',
//     },
//   },
//   {
//     field: 'issuer',
//     headerName: 'יצרן מד',
//     hideable: true,
//     disableAggregation: true,
//     filter: {
//       type: 'options',
//     },
//     filterable: true,
//   },
//   {
//     field: 'openCycle',
//     headerName: 'מעגל פתוח',
//     hideable: true,
//     disableAggregation: true,
//     filter: {
//       type: 'none',
//     },
//     filterable: true,
//   },
]

export default columnsConfig
